const FETCHING_INVOICE_LIST = "@createEditStatement/fetchingInvoiceList";
const FETCHING_INVOICE_LIST_ERROR = "@createEditStatement/fetchingInvoiceListError";
const FETCHING_INVOICE_LIST_SUCCESS = "@createEditStatement/fetchingInvoiceListSuccess";

const FETCHING_STATEMENT = "@createEditStatement/fetchingStatement";
const FETCHING_STATEMENT_SUCCESS = "@createEditStatement/fetchingStatementSuccess";
const FETCHING_STATEMENT_ERROR = "@createEditStatement/fetchingStatementError";

const FETCHING_NAME = "@createEditStatement/fetchingName";
const FETCHING_NAME_SUCCESS = "@createEditStatement/fetchingNameSuccess";
const FETCHING_NAME_ERROR = "@createEditStatement/fetchingNameError";

const CREATE_EDIT_STATEMENT = "@createEditStatement/createEditStatement";
const CREATE_EDIT_STATEMENT_SUCCESS = "@createEditStatement/createEditStatementSuccess";
const CREATE_EDIT_STATEMENT_ERROR = "@createEditStatement/createEditStatementError";

const ADD_INVOICES = "@createEditStatement/addInvoices";
const REMOVE_INVOICES = "@createEditStatement/removeInvoices";
const CLEAR_STORE = "@createEditStatement/clearStore";

export {
  FETCHING_INVOICE_LIST,
  FETCHING_INVOICE_LIST_ERROR,
  FETCHING_INVOICE_LIST_SUCCESS,
  FETCHING_STATEMENT,
  FETCHING_STATEMENT_ERROR,
  FETCHING_STATEMENT_SUCCESS,
  FETCHING_NAME,
  FETCHING_NAME_ERROR,
  FETCHING_NAME_SUCCESS,
  CREATE_EDIT_STATEMENT,
  CREATE_EDIT_STATEMENT_ERROR,
  CREATE_EDIT_STATEMENT_SUCCESS,
  ADD_INVOICES,
  REMOVE_INVOICES,
  CLEAR_STORE
};
